import PasswordSheriff from 'password-sheriff'
import { i18n } from '@/i18n'

export default Validator => {
  Validator.register('password', new PasswordSheriff('fair').check, i18n.t('passwordEnforcementMessage'))
}
